/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */

import VersionNumber from './importer/VersionNumber';

export default {
  LAST_SUPPORTED_FREEMIND_VERSION: '1.0.1',

  SUPPORTED_FREEMIND_VERSION: new VersionNumber('1.0.1'),

  CODE_VERSION: 'tango',

  SECOND_LEVEL_TOPIC_HEIGHT: 25,

  ROOT_LEVEL_TOPIC_HEIGHT: 25,

  CENTRAL_TO_TOPIC_DISTANCE: 200,

  TOPIC_TO_TOPIC_DISTANCE: 90,

  FONT_SIZE_HUGE: 15,

  FONT_SIZE_LARGE: 10,

  FONT_SIZE_NORMAL: 8,

  FONT_SIZE_SMALL: 6,

  NODE_TYPE: 'NODE',

  BOLD: 'bold',

  ITALIC: 'italic',

  EMPTY_FONT_STYLE: ';;;;;',

  EMPTY_NOTE: '',

  POSITION_LEFT: 'left',

  POSITION_RIGHT: 'right',
};
